import { action } from 'typesafe-actions';
import {
  MemberLookupActionTypes,
  MemberLookupJobStatus,
  LivePrice
} from './types';
import { RegisterMemberLookupBody } from 'services/bydaMemberLookup.service';

export const registerMemberLookupStart = (body: RegisterMemberLookupBody) =>
  action(MemberLookupActionTypes.REGISTER_START, body);

export const registerMemberLookupSuccess = (payload: {
  lookupId: number;
  registrationJobId?: number;
}) => action(MemberLookupActionTypes.REGISTER_SUCCESS, payload);

export const registerMemberLookupFailure = (error: string) =>
  action(MemberLookupActionTypes.REGISTER_FAILURE, error);

export const clearMapSketchRegistration = () =>
  action(MemberLookupActionTypes.CLEAR_MAP_SKETCH_REGISTRATION);

export const uploadFileStart = (payload: { file: File }) =>
  action(MemberLookupActionTypes.UPLOAD_FILE_START, payload);

export const uploadFileSuccess = (fileId: number) =>
  action(MemberLookupActionTypes.UPLOAD_FILE_SUCCESS, fileId);

export const uploadFileFailure = (error: string) =>
  action(MemberLookupActionTypes.UPLOAD_FILE_FAILURE, error);

export const clearFileUpload = () =>
  action(MemberLookupActionTypes.CLEAR_FILE_UPLOAD);

export const pollJobStart = (jobId: number) =>
  action(MemberLookupActionTypes.POLL_JOB_START, jobId);

export const pollJobUpdate = (status: MemberLookupJobStatus) =>
  action(MemberLookupActionTypes.POLL_JOB_UPDATE, status);

export const pollJobComplete = (payload?: {
  shapeCount?: number;
  areaKm2?: number;
}) => action(MemberLookupActionTypes.POLL_JOB_COMPLETE, payload);

export const pollJobFailure = (error: string) =>
  action(MemberLookupActionTypes.POLL_JOB_FAILURE, error);

export const fetchLivePriceStart = () =>
  action(MemberLookupActionTypes.FETCH_LIVE_PRICE_START);

export const fetchLivePriceSuccess = (price: LivePrice) =>
  action(MemberLookupActionTypes.FETCH_LIVE_PRICE_SUCCESS, price);

export const fetchLivePriceFailure = (error: string) =>
  action(MemberLookupActionTypes.FETCH_LIVE_PRICE_FAILURE, error);

export const createCheckoutStart = (lookupId: number) =>
  action(MemberLookupActionTypes.CREATE_CHECKOUT_START, lookupId);

export const createCheckoutSuccess = (payload: {
  clientSecret?: string;
  postPaymentId?: number;
  completed?: boolean;
  transactionReference?: string;
}) => action(MemberLookupActionTypes.CREATE_CHECKOUT_SUCCESS, payload);

export const createCheckoutFailure = (error: string) =>
  action(MemberLookupActionTypes.CREATE_CHECKOUT_FAILURE, error);

export const confirmPostpay = () =>
  action(MemberLookupActionTypes.CONFIRM_POSTPAY);

export const resetPaymentCheckout = () =>
  action(MemberLookupActionTypes.RESET_PAYMENT_CHECKOUT);

export const pollCheckoutStatusStart = (sessionId: string) =>
  action(MemberLookupActionTypes.POLL_CHECKOUT_STATUS_START, sessionId);

export const pollCheckoutStatusComplete = (payload: {
  paymentIntentId?: string;
}) => action(MemberLookupActionTypes.POLL_CHECKOUT_STATUS_COMPLETE, payload);

export const pollCheckoutStatusFailure = (error: string) =>
  action(MemberLookupActionTypes.POLL_CHECKOUT_STATUS_FAILURE, error);

export const pollMemberLookupStatusStart = (lookupId: number) =>
  action(MemberLookupActionTypes.POLL_STATUS_START, lookupId);

export const pollMemberLookupStatusUpdate = (status: string) =>
  action(MemberLookupActionTypes.POLL_STATUS_UPDATE, status);

export const pollMemberLookupStatusComplete = () =>
  action(MemberLookupActionTypes.POLL_STATUS_COMPLETE);

export const pollMemberLookupStatusFailure = (error: string) =>
  action(MemberLookupActionTypes.POLL_STATUS_FAILURE, error);

export const fetchDownloadUrlStart = (lookupId: number) =>
  action(MemberLookupActionTypes.FETCH_DOWNLOAD_URL_START, lookupId);

export const fetchDownloadUrlSuccess = (payload: {
  url: string;
  memberCount: number;
  fileName: string;
}) => action(MemberLookupActionTypes.FETCH_DOWNLOAD_URL_SUCCESS, payload);

export const fetchDownloadUrlFailure = (error: string) =>
  action(MemberLookupActionTypes.FETCH_DOWNLOAD_URL_FAILURE, error);

export const resetMemberLookup = () => action(MemberLookupActionTypes.RESET);

export const restoreLookupId = (lookupId: number) =>
  action(MemberLookupActionTypes.RESTORE_LOOKUP_ID, lookupId);
